import { Accordion } from '@material-ui/core';
import styled from 'styled-components';

export const AccordionWrapper = styled(Accordion)`
  margin-top: 16px;
  .accordion-button-icon {
    height: 14px;
    width: 14px;
    margin-right: 8px;
  }
  .accordion {
    width: 100%;
    height: 44px;
    background-color: #f5f5f5;
    border-radius: 4px 4px 0px 0px;
  }
  .Mui-expanded {
    min-height: 33px;
  }
  .MuiAccordionSummary-content {
    display: flex;
    justify-content: space-between;
  }
  .accordion-title {
    min-width: 92px;
    font-size: 14px;
    font-weight: bold;
    color: #0072c6;
    text-transform: uppercase;
    padding: 0 5px;
    align-self: center;
  }
  .accordion-buttons {
  }
  .accordion-buttons > * {
    margin: 0 10px;
    width: 125px;
    height: 36px;
    background-color: transparent;
    border-radius: 4px;
  }
  .accordion-button-el > * {
    margin: 0 10px;
    width: auto;
    height: 36px;
    background-color: transparent;
    border-radius: 4px;
  }
`;
